import { useState } from 'react';
import styled from 'styled-components';

import customDesktopScroll from '~/components/scroll/custom-desktop-scroll';
import Checkbox from '~/components/forms/checkbox';
import { Input } from '@comeon/ui';

import useTranslations from '~/components/translation/use-translations';

const copyArray = arr => {
	const ret = [];

	arr.forEach(elem => {
		ret.push({ ...elem });
	});

	return ret;
};

const CancelButton = styled.button`
	font: var(--label-regular);
`;

const DoneButton = styled.button`
	font: var(--label-regular);
	color: rgba(var(--my-notifications-back-button-color), 1);
`;

const DropdownOption = styled.button`
	display: flex;
	flex: 1;
	margin-top: 16px;
`;

const CheckboxContainer = styled.div`
	margin-top: 5px;
`;

const OptionTextContainer = styled.div`
	text-align: start;
	margin-right: auto;
`;

const OptionTitle = styled.div`
	font: var(--label-regular);
`;

const OptionsContainer = styled.div`
	margin-bottom: 20px;
`;

const OptionsContainerWithCustomScroll = customDesktopScroll(OptionsContainer, '');

const textkeys = ['CANCEL', 'DONE'];

const CheckboxDropdown = ({
	options,
	onSubmit = () => {},
	setDropdownOpen,
	dropdownPlaceHolderText,
	setDropdownText
}) => {
	const {
		translations: { CANCEL, DONE },
		isLoadingTranslations
	} = useTranslations(textkeys);

	const [confirmedOptions, setConfirmedOptions] = useState(copyArray(options));
	const [tempOptions, setTempOptions] = useState(copyArray(options));

	const toggleSelected = title => {
		const idxToUpdate = tempOptions.findIndex(opt => opt.title === title);

		if (idxToUpdate !== -1) {
			const newTempOptions = [...tempOptions];
			newTempOptions[idxToUpdate] = {
				...newTempOptions[idxToUpdate],
				isChecked: !newTempOptions[idxToUpdate].isChecked
			};
			setTempOptions(newTempOptions);
		}
	};

	const changeCustomValue = (title, newCustomValue) => {
		const idxToUpdate = tempOptions.findIndex(opt => opt.title === title);

		if (idxToUpdate !== -1) {
			const newTempOptions = [...tempOptions];
			newTempOptions[idxToUpdate] = { ...newTempOptions[idxToUpdate], value: newCustomValue };
			setTempOptions(newTempOptions);
		}
	};

	const handleDoneClick = () => {
		setDropdownOpen(false);
		onSubmit(
			tempOptions.reduce((acc, curr) => {
				if (curr.isChecked) {
					acc.push(curr.value);
				}
				return acc;
			}, [])
		);
		setConfirmedOptions(copyArray(tempOptions));

		// Format the Dropdown Placeholder Text
		let text = '';
		text = tempOptions
			.reduce((acc, curr) => {
				if (curr.isChecked) {
					if (curr.isCustom) {
						acc.push(curr.value);
					} else {
						acc.push(curr.title);
					}
				}

				return acc;
			}, [])
			.join(', ');
		if (text.length > 36) {
			text = `${text.substring(0, 36)}...`;
		}

		if (text.length === 0) {
			text = dropdownPlaceHolderText;
		}

		setDropdownText(text);
	};

	if (isLoadingTranslations) {
		return null;
	}

	return (
		<div className="sow-options-wrapper">
			<div className="sow-options">
				<div className="sow-dropdown-cta-button">
					<CancelButton
						onClick={() => {
							setDropdownOpen(false);
							setTempOptions(copyArray(confirmedOptions));
						}}
					>
						{CANCEL}
					</CancelButton>
					<DoneButton onClick={handleDoneClick}>{DONE}</DoneButton>
				</div>

				<div className="sow-dropdown-buttons-wrapper">
					<OptionsContainerWithCustomScroll>
						{tempOptions.map(option => (
							<DropdownOption
								key={option.title}
								onClick={e => {
									toggleSelected(option.title);
									e.stopPropagation();
									e.preventDefault();
								}}
							>
								<CheckboxContainer>
									<Checkbox
										onChange={e => {
											toggleSelected(option.title);
											e.stopPropagation();
											e.preventDefault();
										}}
										isChecked={option.isChecked}
									/>
								</CheckboxContainer>
								<OptionTextContainer>
									<OptionTitle>{option.title}</OptionTitle>
									<small>{option.subtitle}</small>
									{option.isCustom && option.isChecked && (
										<Input
											autoFocus
											onChange={e => {
												changeCustomValue(option.title, e.target.value);
												e.stopPropagation();
												e.preventDefault();
											}}
											onClick={e => {
												e.stopPropagation();
												e.preventDefault();
											}}
											onKeyDown={e => {
												if (e.code === 'Space') {
													changeCustomValue(option.title, `${e.target.value} `);
													e.preventDefault();
													e.stopPropagation();
												}
											}}
											placeholder={option.placeholder}
											value={option.value}
											maxlength="100"
										/>
									)}
								</OptionTextContainer>
							</DropdownOption>
						))}
					</OptionsContainerWithCustomScroll>
				</div>
			</div>
		</div>
	);
};

export default CheckboxDropdown;
